import { useSelector } from 'react-redux';

export default () => {
  const groups = useSelector((state) => state.user.securityGroups);

  return groups?.length > 0;
};
